(async () => {
    const baseComponent = await import(window.theme.modules.baseComponent);

    customElements.define('recipient-form-fields', class extends baseComponent.default {
        elements = {
            fieldRefs: '*[data-field-ref]',
            fieldsTrigger: '[data-fields-trigger]'
        }

        render() {
            this.$fieldsTrigger.addEventListener('change', this._handleTriggerChange.bind(this));

          this.offsetProperty = this.querySelector(
            '[name="properties[__shopify_offset]"]'
          );
          if (this.offsetProperty) {
            this.offsetProperty.value = /* @__PURE__ */ new Date()
              .getTimezoneOffset()
              .toString();
          }
        }

        _handleTriggerChange({ target }) {
            this._toggleFieldsDisable(!target.checked);
        }

        _toggleFieldsDisable(state) {
            this.$fieldRefs.map(field => field.disabled = state);
        }
    });
})();
